var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatformArow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 21.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6033",
    "data-name": "Path 6033",
    d: "M30,15.957a.987.987,0,0,1-.293.7l-10,9.96a1,1,0,1,1-1.414-1.409l9.293-9.256L18.293,6.7a1,1,0,1,1,1.414-1.409l10,9.961a.987.987,0,0,1,.293.7Zm-5,0a.987.987,0,0,0-.293-.7l-10-9.96A1,1,0,0,0,14,5H3a1,1,0,0,0-.707,1.7l9.293,9.256L2.293,25.213A1,1,0,0,0,3,26.913H14a1,1,0,0,0,.707-.292l10-9.961a.987.987,0,0,0,.293-.7Z",
    transform: "translate(-2 -5)",
    fill: "#96006b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformArow);
export default __webpack_public_path__ + "static/media/platform-arow.dfa9f05aa2df4429b2f24d8153c8be18.svg";
export { ForwardRef as ReactComponent };